import Input from '@/ui/members/components/form/Input/Input';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const PhoneInput = ({ autoFocus, label = 'Phone Number', onChange, value }: Props) => {
  return (
    <Input
      autoFocus={autoFocus}
      id="phone-number"
      inputMode="numeric"
      label={label}
      onChange={onChange}
      placeholder="(___)___-____"
      type="tel"
      typeHelper="phone"
      value={value}
    />
  );
};

export default PhoneInput;
